module.exports = __webpack_public_path__ + "static/media/NoImageAvailable.b080659e.png";